import React from 'react';
import PropTypes from 'prop-types';
import findLastIndex from 'lodash.findlastindex';
import isNil from 'lodash.isnil';
import ContentTitleSection from './ContentTitleSection';
import ContentParagraph from './ContentParagraph';
import './BasicComprehensionProbeDetails.scss';

const ITEM = 'item';

const parseParagraphs = str => {
    const pattern = /\\\\%%\d+/gi;
    const splited = str.split(pattern);
    const nums = str.match(pattern).map(part => Number(part.match(/\d+/g)));

    return splited.reduce(
        (accum, current, index) =>
            isNil(nums[index]) ? [...accum, current] : [...accum, current, nums[index]],
        [],
    );
};

const BasicComprehensionProbeDetails = props => {
    const { content, result } = props;
    const { itemLevelDetails } = result;
    const { questions, correctResponses } = content;
    const paragraphs = parseParagraphs(questions.paragraphs.join(' '));
    const firstNotAnswered = itemLevelDetails.responses.find(item => item.outcome === 'NA');
    const firstNotAnsweredItemId = firstNotAnswered
        ? Number(firstNotAnswered.item_id.substring(ITEM.length, firstNotAnswered.item_id.length))
        : null;
    const lastSelectedIndex = findLastIndex(
        paragraphs,
        item => typeof item === 'number' && item === firstNotAnsweredItemId,
    );
    const selectedTextPart = paragraphs.splice(
        0,
        lastSelectedIndex <= 1 ? paragraphs.length : lastSelectedIndex,
    );
    return (
        <div className="container">
            <div className="maze-probe-redesign">
                <div className="row">
                    <div className="col-10">
                        <ContentTitleSection
                            title={questions.title}
                            itemLevelDetails={itemLevelDetails}
                        />
                        <div className="content-text">
                            <div className="maze-text">
                                <ContentParagraph
                                    text={selectedTextPart}
                                    questions={questions.items}
                                    selectedResponses={itemLevelDetails.responses}
                                    correctResponses={correctResponses}
                                    isSelected
                                    showBracket={lastSelectedIndex !== 1}
                                />
                                <ContentParagraph
                                    text={paragraphs}
                                    questions={questions.items}
                                    selectedResponses={itemLevelDetails.responses}
                                    correctResponses={correctResponses}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

BasicComprehensionProbeDetails.defaultProps = {
    content: {},
};

BasicComprehensionProbeDetails.propTypes = {
    content: PropTypes.object,
    result: PropTypes.object.isRequired,
};

export default BasicComprehensionProbeDetails;
